<template>
    <div>
        <CommonPopupFrame :changeHeight="80" :closeCompleteAction="closeAction" :isOpen="isOpen" :changeBottom="0" :is-back-press-apply="true">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div style="padding-left: 12px; margin-top: 12px; border-bottom: 1px solid #ebebeb; padding-bottom: 16px;">
                <div style="display: flex; align-items: center; gap: 8px; position: relative;">
                    <img @click="closeAction" style="width: 42px" :src="require('@/assets/img/recent_x_btn.png')" alt="" />
                    <div style="position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700;">초대하기</div>
                </div>
            </div>
            <div style="flex: 1; overflow: hidden;" @touchmove.stop="() => { }">
                <InfinityScroll :handle-next-page="handleNextPage" :is-enable-next-page-handle="isEnableNextPageHandle" :refresh-action="refresh" style="height: 100%;">
                    <div style="position: sticky; z-index: 10; top:0; background-color: #fff; padding-top: 12px; ">
                        <div style="position: relative; padding: 0 12px;">
                            <MercenarySearchInput :enter="enter" :searchWord="searchWord" :setSearchWord="setSearchWord" :placeholder="'이름, 포지션, 나이대 등 검색'"></MercenarySearchInput>
                        </div>
                        <div style="display: flex; padding: 0 24px; justify-content: space-between; margin-top: 20px; border-bottom: 1px solid #ebebeb; padding-bottom: 10px;">
                            <div @click="setSubTabList(each)" :class="subTab === each.title ? 'sub_active' : ''" class="tab_list" v-for="each, i in subTabList" :key="i + 'sub'">{{ each.title }} {{ each.cnt }}명</div>
                        </div>
                    </div>
                    <div style="padding: 0 12px;">
                        <div style="margin-top: 20px; font-weight: 700; margin-bottom: 20px;">근처에서 활동중인 모든 사람</div>
                        <div v-for="each, i in activeMemberList" :key="i" :style="{ paddingTop: i !== 0 ? '12px' : '' }" style="display: flex; justify-content: space-between; padding-bottom: 12px; border-bottom: 1px solid #ebebeb;">
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <div @click.stop="$Util.showProfile(each.member_idx, each.member_type, '', each.is_coach)">
                                    <ProfileImage style="width: 40px;" :imagePath="each.image_path"></ProfileImage>
                                </div>
                                <div style="display: flex; align-items: center; gap: 4px;">
                                    <div style="font-weight: 700; font-size: 12px;">{{ each.nic_name }}</div>
                                    <div style="font-weight: 900; font-size: 11px; color: #808080;">{{ $Util.position_display_str(each.member_type, each.position, each.is_coach) }}</div>
                                </div>
                            </div>
                            <div @click="setIsOpenInviteScheduleModal(each)" style="width: 90px; height: 36px; line-height: 36px; text-align: center; border-radius: 12px; background-color: #f5f5f5; color: var(--color-main); font-size: 12px; font-weight: 500;">초대하기</div>
                        </div>
                    </div>
                </InfinityScroll>
            </div>
        </CommonPopupFrame>
        <InviteMySchedule :memberInfo="memberInfo" :isOpen="isOpenInviteScheduleModal" :closeCompleteAction="closeInviteScheduleModal"></InviteMySchedule>
    </div>
</template>

<script>
import CommonPopupFrame from "@/components/modal/my/CommonPopupFrame";
import MercenarySearchInput from "@/components/common/MercenarySearchInput"
import InviteMySchedule from '@/components/common/InviteMySchedule';
import InfinityScroll from "@/components/common/InfinityScroll"
import ProfileImage from "@/components/common/ProfileImage"

const SUB_TAB_LIST = {
    WHOLE: '전체',
    MEMBER: '멤버',
    RECENT: '최근 본 사람',
    WITH_MERC: '함께한 용병'
}

const SUB_TAB_KEY = {
    ALL: 'all',
    RECENT: 'recent',
    TOGETGHER: 'together',
    MEMBER: 'member'
}

export default {
    name: "InviteMemberPopup",
    components: { CommonPopupFrame, MercenarySearchInput, InfinityScroll, ProfileImage, InviteMySchedule },
    props: {
        region_code: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            isEnableNextPageHandle: true,
            wholeCnt: 0,
            memberCnt: 0,
            recentCnt: 0,
            withMercCnt: 0,
            isOpen: false,
            searchWord: '',
            subTabList: [
                { title: '전체', cnt: 0, key: 'all' },
                { title: '멤버', cnt: 0, key: 'member' },
                { title: '최근 본 사람', cnt: 0, key: 'recent' },
                { title: '함께한 용병', cnt: 0, key: 'together' },
            ],
            subTab: SUB_TAB_LIST.WHOLE,
            subTabKey: SUB_TAB_KEY.ALL,
            SUB_TAB_KEY: SUB_TAB_KEY,
            SUB_TAB_LIST: SUB_TAB_LIST,
            activeMemberList: [],
            page: 1,
            isOpenInviteScheduleModal: false,
            memberInfo: {},
        }
    },
    methods: {
        closeInviteScheduleModal() {
            this.isOpenInviteScheduleModal = false
        },
        async getMemberList(isSearch) {
            if (isSearch) {
                this.page = 1
                this.activeMemberList = []
            }
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.page = this.page;
            parameters.type = this.subTabKey
            parameters.region_code = this.region_code ? this.region_code.slice(0, 8) : this.$GlobalStore.loginInfo().region_code.slice(0, 8)
            parameters.searchWord = this.searchWord === '' ? null : this.searchWord;
            parameters.is_without_region = true;

            const res = await this.$Axios.get('/api/member/region/list', { params: parameters })
            const result = res.data.members

            if (result.length > 0) {
                this.isEnableNextPageHandle = true;
                this.activeMemberList = [...this.activeMemberList, ...result];
            }
        },
        initializeSubTabList() {
            this.subTabList = [
                { title: '전체', cnt: this.wholeCnt, key: 'all' },
                { title: '멤버', cnt: this.memberCnt, key: 'member' },
                { title: '최근 본 사람', cnt: this.recentCnt, key: 'recent' },
                { title: '함께한 용병', cnt: this.withMercCnt, key: 'together' },
            ]
        },
        async getSummary() {
            const parameters = {}
            parameters.region_code = this.region_code ? this.region_code.slice(0, 8) : this.$GlobalStore.loginInfo().region_code.slice(0, 8);
            parameters.searchWord = this.searchWord === '' ? null : this.searchWord;
            parameters.is_without_region = true;
            const res = await this.$Axios.get('/api/member/region/list/statis', { params: parameters })

            this.wholeCnt = res.data.all_cnt
            this.memberCnt = res.data.member_cnt
            this.recentCnt = res.data.recent_cnt
            this.withMercCnt = res.data.together_cnt

            this.initializeSubTabList()
        },
        setIsOpenInviteScheduleModal(member_info) {
            this.isOpenInviteScheduleModal = true;
            this.memberInfo = member_info
        },
        handleNextPage() {
            this.page++
            this.getMemberList()
        },
        refresh() {
            this.page = 1
            this.activeMemberList = []
            this.getMemberList()
        },
        setSearchWord(result) {
            this.searchWord = result
        },
        enter(e) {
            this.searchWord = e.target.value
            if (e.keyCode === 13) {
                this.getMemberList(true)
            }
        },
        setSubTabList(item) {
            this.subTab = item.title
            this.subTabKey = item.key
            this.activeMemberList = []
            this.page = 1
            this.getMemberList()
        },
        closeAction() {
            if (this.isOpen) {
                this.isOpen = false;
                return;
            }
            setTimeout(() => {
                this.$GlobalStore.closeLastModal();
            }, 300)
        },
        ActBeforeClose() {
            this.isOpen = false;
        },
    },
    mounted() {
        setTimeout(() => {
            this.isOpen = true;
        }, 100)
    },
    created() {
        this.getMemberList()
        this.getSummary()
    }
}
</script>

<style scoped>
.circle_s {
    display: inline-block;
    width: 2px;
    height: 2px;
    background-color: #606060;
    border-radius: 50%;
}

.active {
    background-color: #210F03;
    color: #fff;
}

.active div {
    color: #fff;
}

.un_active {
    background-color: #f5f5f5;
}

.un_active>div:nth-child(2) {
    color: #606060;
}

.tab_list {
    font-weight: 700;
    font-size: 12px;
    position: relative;
}

.sub_active::after {
    content: '';
    height: 2px;
    background-color: #210F03;
    position: absolute;
    width: calc(100% + 20px);
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
}
</style>